export default "__VITE_ASSET__BMtTp61A__"